import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import resumePDF from '../assets/JUDITH OYUGI CV.pdf';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      
      const sections = ['home', 'about', 'skills', 'projects', 'contact'];
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    setIsMenuOpen(false);
    document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
  };

  const handleResumeClick = () => {
    window.open(resumePDF, '_blank');
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <span className="logo-text">JO</span>
        </div>

        <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <motion.div className={`hamburger-lines ${isMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </motion.div>
        </div>
        
        <AnimatePresence>
          {isMenuOpen && (
            <motion.nav className="mobile-nav">
              <ul className="mobile-nav-links">
                {['home', 'about', 'skills', 'projects', 'contact'].map((section) => (
                  <motion.li 
                    key={section}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.2 }}
                  >
                    <button 
                      onClick={() => scrollToSection(section)} 
                      className={`nav-link ${activeSection === section ? 'active' : ''}`}
                    >
                      {section.charAt(0).toUpperCase() + section.slice(1)}
                    </button>
                  </motion.li>
                ))}
                <motion.li>
                  <button onClick={handleResumeClick} className="resume-btn mobile-resume">
                    Resume
                  </button>
                </motion.li>
              </ul>
            </motion.nav>
          )}
        </AnimatePresence>

        <nav className="desktop-nav">
          <ul className="nav-links">
            {['home', 'about', 'skills', 'projects', 'contact'].map((section) => (
              <li key={section}>
                <button 
                  onClick={() => scrollToSection(section)} 
                  className={`nav-link ${activeSection === section ? 'active' : ''}`}
                >
                  {section.charAt(0).toUpperCase() + section.slice(1)}
                </button>
              </li>
            ))}
          </ul>
          <button onClick={handleResumeClick} className="resume-btn">Resume</button>
        </nav>
      </div>
    </header>
  );
};

export default Header;